import { useMutation, useQueryClient } from "@tanstack/react-query";
import { requestCategoryService } from "../services/requestCategory.service";

export const useDeleteRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (requestId: string) => requestCategoryService.deleteRequest(requestId),
    onSuccess: () => {
      // Invalidate requests query to refetch the updated list
      queryClient.invalidateQueries({ queryKey: ["requests"] });
    },
  });
};
